export const HOMEPAGE = '/';
export const HOMEPAGE_LOGIN = '/#/login';
export const logout = (csrfToken, redirectTo = HOMEPAGE) => new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/myaccount/customer/logout/');
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.onload = () => {
        if (xhr.status === 200 || xhr.status === 302) {
            try {
                resolve();
            }
            catch (e) {
                reject(e);
            }
        }
        else if (xhr.status !== 200) {
            reject(new Error(xhr.responseText));
        }
    };
    xhr.send(`csrfToken=${csrfToken}`);
})
    .then(() => {
    window.location.href = redirectTo;
})
    // eslint-disable-next-line no-console
    .catch(console.error); // If an error happens we don't do anything, let the user try again;
//# sourceMappingURL=logout.js.map